import styled from "styled-components/macro";

export const StyledContainer = styled.div`
  text-align: left;
  font-family: "GT Super Text";
  padding: 25px 0 0 0;
  margin: 0;
  height: 100%;
  max-height: 100vh;
  background: white;

  /* display: flex; */
  /* flex-direction: column; */
  /* overflow: hidden; */

  .reviser-content {
    display: grid;
    grid-template-rows: auto minmax(0, 1fr) auto;
    grid-template-columns: 350px 1fr;
    height: calc(100vh - 95px);
    grid-template-areas:
      "header header"
      "nav main"
      "footer footer";
  }

  .scroll-left {
    overflow: scroll;
    flex: 1;
  }

  header {
    grid-area: header;
    background: turquoise;
  }

  .diff-match-patch-viewer {
    font-family: "Quattro";
    padding: 0.5rem;
  }

  nav {
    grid-area: nav;
    /* width: 300px; */
    display: flex;
    flex-direction: column;
    gap: 1rem;
    min-height: 100px;
    padding: 0 15px 15px 15px;

    .styled-select-container {
      width: 306px;
    }
  }

  .main {
    grid-area: main;
    text-align: left;
    min-height: 100px;
    max-width: none;

    .original-container,
    .revised-container,
    .inline-container {
      height: calc(100vh - 125px);
      overflow-y: auto;

      textarea {
        padding: 1rem;
      }
    }
  }

  .left-pane,
  .right-pane,
  .main {
    #mergely-2 {
      height: auto !important;
    }
    .mergely-editor .CodeMirror {
      font-family: "Quattro" !important;
    }
    .mergely-splash {
      display: none;
    }
  }

  .pane-content {
    /* flex: 1; */

    padding: 20px;
  }

  .left-pane {
    flex-grow: 3;
    width: 550px;
    overflow-y: auto;
    height: 500px;

    .pane-content {
      width: 350px;
    }
  }

  .right-pane {
    flex-grow: 1;
  }

  .button-group {
    /* display: flex;
    gap: 10px; */
    margin-bottom: 20px;
    padding-top: 15px;

    label {
      font-size: 13px;
    }
  }

  #error {
    position: fixed;
    bottom: 12px;
    color: var(--context-menu-text);
    z-index: 50000;
    padding: 15px;
    border-radius: 8px;
    left: 50%;
    transform: translate(-50%, 0);
    background: var(--grey-0);
    animation: shake 0.52s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
    backface-visibility: hidden;
    line-height: 1.3em;

    a {
      color: var(--grey-4);
      text-decoration: underline;
    }
  }

  h1 {
    margin: 0 0 25px 20px;
  }

  h2 {
    margin-top: 0;
  }

  button {
    margin-bottom: 0;
    margin-right: 5px;
    padding: 5px 12px !important;
    height: 35px;
    vertical-align: middle;
    line-height: 15px;

    &:disabled {
      background: var(--grey-2) !important;
    }
  }

  .button-group {
    margin-bottom: 25px;
  }

  textarea {
    width: calc(100% - 35px);
    margin-bottom: 0px;
    font-size: 16px;
    line-height: 21px;
    font-family: "Quattro" !important;
    border-radius: 4px;
  }

  small {
    font-size: 14px;
    color: var(--grey-1);
  }

  .warning-message {
    margin-top: 10px;
    small {
      color: red;
      font-size: 14px;
    }
  }

  .instructions {
    padding: 10px;
  }

  .todo-buttons {
    margin-bottom: 10px;
  }

  .todos {
    overflow-y: auto;
    ul {
      padding-left: 0;
      list-style-type: none;
      li {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        textarea {
          padding: 10px;
          margin-top: 0;
          width: 95%;
          border-radius: 4px;
        }
        a {
          margin-left: 10px;
          cursor: pointer;
        }
      }
    }
  }

  .diff-mode-toggle {
    margin-top: -25px;
  }
`;

export const DiffModeButton = styled.button`
  background: ${(props) => (props.active ? "var(--primary-cta) !important" : "transparent !important")};
  color: ${(props) => (props.active ? "white" : "var(--primary-cta) !important")};
  border: ${(props) => (props.active ? "none" : "1px solid var(--primary-cta) !important")};
  padding: 8px 16px;
  margin: 0 4px;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.3s, color 0.3s;

  &:hover {
    background-color: ${(props) => (props.active ? "#45a049" : "#e0e0e0")};
  }
`;
